import { InjectionToken } from '@angular/core';
import { Environment } from '../types/environment';

export const ENVIRONMENT = new InjectionToken<Environment>(
  '85aab452-0850-47d0-b77e-e62e05218116',
);
